import React from 'react';
import SnackBar from './SnackBar';

const SnackBarContainer = ({ snackBars, onDismiss }) => {
  return (
    <div className="fixed bottom-0 left-1/2 -translate-x-1/2 md:bottom-4 md:right-4 md:left-auto md:translate-x-0 z-[9999] flex flex-col items-center md:items-end gap-2 p-4 pointer-events-none">
      {snackBars.map((snack) => (
        <SnackBar
          key={snack.id}
          {...snack}
          onClose={() => {
            if (snack.onClose) snack.onClose();
            onDismiss(snack.id);
          }}
        />
      ))}
    </div>
  );
};

export default SnackBarContainer;
